/**
 * 解析の呼び出し口。Worker が使えればそちら、なければメインスレッド。
 */

import type { AnalysisRequest, AnalysisResult } from '@kensuke/genome-core';
import {
  runGeneAnalysisAnalyze,
  type GeneAnalysisAnalyzeRequest,
  type GeneAnalysisAnalyzeResponse,
} from '../workers/geneAnalysisAnalysisWorker';

export function analyzeSequenceWindow(
  request: AnalysisRequest,
  codes: Uint8Array,
  forceMainThread = false
): Promise<AnalysisResult> {
  const message: GeneAnalysisAnalyzeRequest = { type: 'ANALYZE', request, codes };

  if (forceMainThread || typeof Worker === 'undefined') {
    return Promise.resolve(runGeneAnalysisAnalyze(message).result);
  }

  return new Promise((resolve, reject) => {
    let worker: Worker;
    try {
      worker = new Worker(new URL('../workers/geneAnalysisAnalysisWorker.ts?worker', import.meta.url), {
        type: 'module',
      });
    } catch {
      resolve(runGeneAnalysisAnalyze(message).result);
      return;
    }

    const finish = (action: () => void) => {
      worker.terminate();
      action();
    };

    worker.onmessage = (event: MessageEvent<GeneAnalysisAnalyzeResponse>) => {
      const payload = event.data;
      if (payload.type === 'DONE') {
        finish(() => resolve(payload.result));
        return;
      }
      finish(() => reject(new Error(payload.message)));
    };
    worker.onerror = (event) => {
      finish(() => reject(new Error(event.message || '解析 Worker でエラーが発生しました')));
    };

    const transfer = codes.slice();
    worker.postMessage({ ...message, codes: transfer }, [transfer.buffer]);
  });
}
